import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";

export default function Lightbox({ src, alt = "", onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
      onClick={onClose}
      data-testid="lightbox-overlay" data-lenis-prevent
      className="fixed inset-0 z-[100] flex cursor-zoom-out items-center justify-center bg-ink/85 p-6 backdrop-blur-sm"
    >
      <motion.img
        initial={{ scale: 0.92, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }}
        transition={{ duration: 0.3, ease: [0.19, 1, 0.22, 1] }}
        src={src} alt={alt} data-testid="lightbox-image"
        className="max-h-[90vh] max-w-[90vw] border border-line bg-cream object-contain"
      />
      <button onClick={onClose} data-testid="lightbox-close" aria-label="Fermer"
        className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center border border-cream/30 text-cream transition-colors hover:bg-cream hover:text-ink">
        <X className="h-5 w-5" />
      </button>
    </motion.div>
  );
}
